













import { Component, Prop, Vue } from "vue-property-decorator";

// The easter egg: a pixel duck perched on the footer's ground. Clicking it, or typing "flap"
// anywhere outside a text field, starts QuACSy Bird.
@Component({
  components: {
    FlappyGame: () => import("@/components/themes/FlappyGame.vue"),
  },
})
export default class FlappyDecor extends Vue {
  @Prop({ required: true }) readonly place!: string;

  playing = false;
  typed = "";

  mounted(): void {
    if (this.place === "bottom") {
      window.addEventListener("keydown", this.onKey);
    }
  }

  beforeDestroy(): void {
    window.removeEventListener("keydown", this.onKey);
  }

  onKey(event: KeyboardEvent): void {
    const target = event.target as HTMLElement | null;
    if (
      this.playing ||
      event.key.length !== 1 ||
      (target &&
        (target.isContentEditable ||
          ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName)))
    ) {
      return;
    }
    this.typed = (this.typed + event.key.toLowerCase()).slice(-4);
    if (this.typed === "flap") {
      this.typed = "";
      this.playing = true;
    }
  }
}
